import { render } from "./CartCard.vue?vue&type=template&id=1f2bc04d"
import script from "./CartCard.vue?vue&type=script&lang=js"
export * from "./CartCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/vhosts/hypergen.be/pcz.hypergen.be/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__